<div class="full-plan">
  <div class="row justify-content-center">
    <div class="col-12 mb-4">
      <h1 class="mb-5" [translate]="'plan/choose-your'">Escolha seu <b class="ml-2" [translate]="'plan/plan'">plano</b></h1>
    </div>
    <div class="col-12 mb-4" *ngIf="role === 'SOLUTION_PROVIDER'">
      <div class="row justify-content-center align-items-center plan-toggle-row">
        <div class="col-auto">
          <mat-slide-toggle
            class="plan-recurrence-toggle"
            color="accent"
            [checked]="recurrenceType === 'ANNUAL'"
            (change)="togglePlan()">
            {{ 'plan/annual-price' | translate}}
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="plans.length">
    <div class="row mt-3">
      <p-carousel class="col-12" [value]="plans" [numVisible]="3" [numScroll]="1" [page]="0"
        [responsiveOptions]="responsiveOptions" [showNavigators]="true">
        <ng-template let-plan pTemplate="item">
          <ng-container *ngTemplateOutlet="planTemplate; context: { plan: plan }"></ng-container>
        </ng-template>
      </p-carousel>
    </div>
  </ng-container>
</div>

<ng-template #planTemplate let-plan="plan">
  <div class="full-plan-container mx-2">
    <div class="row justify-content-center full-plan-header">
      <div class="col-12 text-center full-plan-header-title">{{ plan.name }}</div>
      <div class="col-12 text-center full-plan-header-price mt-3">
        <ng-container *ngIf="plan.prices[0].value">
          <span>
            <span>{{ plan.prices[0].value | currency : plan.prices[0].currencyType : 'symbol' : '1.2-2' }}</span>
            <ng-container *ngIf="plan?.usersAllowed != 0">
              <span>{{ (role === 'SOLUTION_PROVIDER' && recurrenceType === 'MONTHLY' ? 'plan/month' : 'plan/year') |
                translate }}</span>
            </ng-container>
          </span>
        </ng-container>
        <ng-container *ngIf="!plan.prices[0].value">FREE</ng-container>
        <div *ngIf="role === 'PUBLIC_ADMINISTRATOR' && !plan.prices[0].value && !planSize" style="margin-bottom: 3.6rem;">
        </div>
      </div>
      <div *ngIf="recurrenceType === 'ANNUAL'" class="col-12 text-center full-plan-header-equivalent">
        <div *ngIf="plan.monthlyValue && plan?.usersAllowed != 0">
          <span>
            <span [translate]="'plan/equivalent'"></span>
            <span> {{ plan.monthlyValue | currency : plan.prices[0].currencyType : 'symbol' : (role ===
              'SOLUTION_PROVIDER' ?
              '1.2-2' : '1.0-0') }}/mês </span>
          </span>
        </div>
      </div>
      <div class="col-12 text-center full-plan-header-period">{{ plan.description }}</div>
      <div *ngIf="role === 'SOLUTION_PROVIDER'" class="col-12 text-center full-plan-header-trial">
        <div *ngIf="plan.freeTrialPeriodInDays">
          <span>
            <span [translate]="'plan/free-trial'"></span>:
            <span>{{plan.freeTrialPeriodInDays}} </span>
            <span [translate]="'plan/days'"></span>
          </span>
        </div>
      </div>
      <div class="full-plan-header-btn m-3">
        <button mat-flat-button (click)="choosePlan(plan.id, recurrenceType)"
                [ngClass]="this.userInfoPayload?.planId == plan.id ? 'disabled-plan-button' : null"><span
            [translate]="'choose-plan/title'"></span></button>
      </div>
      <ng-container *ngIf="this.userInfoPayload?.planId == plan.id">
        <div class="full-plan-itens-item full-plan-itens-item-enabled text-center fw-bold active-plan-title">
          <i class="fas fa-check-circle mr-2"></i>
          Seu plano atual!
        </div>
      </ng-container>
    </div>
    <div class="full-plan-itens mt-3">
      <ng-container *ngIf="plan?.usersAllowed == 0; else usersAllowedEnabled">
        <div class="full-plan-itens-item full-plan-itens-item-disabled">
          <i class="fas fa-times-circle mr-2"></i>
        </div>
        <div class="full-plan-itens-item full-plan-itens-item-disabled">
          <span [translate]="'plan/platform-access'">
            Acessos a plataforma
          </span>
        </div>
      </ng-container>
      <ng-template #usersAllowedEnabled>
        <div class="full-plan-itens-item full-plan-itens-item-enabled ">
          <i class="fas fa-check-circle mr-2"></i>
        </div>
        <div class="full-plan-itens-item full-plan-itens-item-enabled">
          <span>
            <span [translate]="'plan/platform-access'" *ngIf="plan?.usersAllowed === 1">
              Acessos a plataforma
            </span>
            <span [translate]="'plan/platform-accesses'" *ngIf="plan?.usersAllowed === null || plan?.usersAllowed > 1">
              Acessos a plataforma
            </span>:
            <ng-container *ngIf="!plan?.usersAllowed">
              <span class="ml-1" [translate]="'plan/unlimited'"></span>
            </ng-container>
            <ng-container *ngIf="plan?.usersAllowed >= 1">
              <span class="ml-1">{{plan?.usersAllowed}}</span>
            </ng-container>
          </span>
        </div>
      </ng-template>
    </div>
    <ng-container *ngFor="let feature of plan.features">
      <div class="full-plan-itens mt-3" (click)="featureClick(featureItemsEl)">
        <ng-container *ngIf="feature.enabled; else notEnabled">
          <div class="full-plan-itens-item full-plan-itens-item-enabled ">
            <i class="fas fa-check-circle mr-2"></i>
          </div>
          <div class="full-plan-itens-item full-plan-itens-item-enabled"
            [ngClass]="{'full-plan-itens-item-with-item': feature?.items && feature?.items.length}">
            {{ feature.name }}
          </div>
        </ng-container>
        <ng-template #notEnabled>
          <div class="full-plan-itens-item full-plan-itens-item-disabled">
            <i class="fas fa-times-circle mr-2"></i>
          </div>
          <div class="full-plan-itens-item full-plan-itens-item-disabled">
            {{ feature.name }}
          </div>
        </ng-template>
        <div class="feature-chevron-icon" *ngIf="feature?.items && feature?.items.length">
          <ng-container *ngIf="featureIsOpen(featureItemsEl)">
            <i class="fal fa-chevron-up"></i>
          </ng-container>
          <ng-container *ngIf="!featureIsOpen(featureItemsEl)">
            <i class="fal fa-chevron-down"></i>
          </ng-container>
        </div>
        <br>
        <div class="stamp" *ngIf="feature.stampUrl">
          <img [src]="feature.stampUrl">
        </div>
      </div>
      <div #featureItemsEl class="full-plan-itens-item-extended">
        <ul>
          <ng-container *ngFor="let item of feature?.items">
            <li class="full-plan-itens-item-extended-item">{{ item }}</li>
          </ng-container>
        </ul>
      </div>
    </ng-container>
  </div>
</ng-template>
